import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    iconButton: {
        marginLeft: '0.5rem',
    },
    actionList: {
        display: 'flex',
        alignItems: 'center',
    },
}));
